import React from 'react';
import _ from 'lodash';

import PouchInput from 'components/PouchInput';

const WeightClassCell = ({data, column, meet, style}) => {
  const division = data;
  if(division.row === 'header') {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else {
    return (
      <div style={style} className="table-cell-inner">
        {
          _.map(_.sortBy(division.weightClasses, (weightClass) => _.toNumber(weightClass.maxWeight)), (weightClass) => {
            return (
              <div key={weightClass._id} className="inner-row">
                {/* Old version before schema stored weight classes as individual docs */}
                { division.schema ? (
                  <PouchInput
                    type={column.type}
                    meetId={meet._id}
                    documentId={division._id}
                    name={['weightClasses', weightClass._id, column.key]}
                    value={_.get(division, ['weightClasses', weightClass._id, column.key])}
                  /> ) : (
                  <PouchInput
                    type={column.type}
                    meetId={meet._id}
                    documentId={weightClass._id}
                    name={column.key}
                    value={_.get(division, ['weightClasses', weightClass._id, column.key])}
                  />)
                }
              </div>
            );
          })
        }
      </div>
    );
  }
};

export default WeightClassCell;
